export const PRODUCT_TYPE_COOKIE_NAME = "OBG-LOBBY";
